import { Link } from 'react-router-dom';
import { useState } from 'react';

const NutrarePage = () => {
  const [selectedCategory, setSelectedCategory] = useState('Todos');

  const products = [
    {
      id: 1,
      name: 'Achocolatado',
      weight: '1,01 kg',
      category: 'Achocolatado',
      image: 'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/2e148fef00e43df5e320940e473e687c.png',
      description: 'Alimento achocolatado em pó de alta qualidade.'
    },
    {
      id: 2,
      name: 'Bebida láctea',
      weight: '1 kg',
      category: 'Bebida',
      image: 'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/6c6bc8a30118df848debcc8655fca8de.png',
      description: 'Mistura para o preparo de bebida sabor chocolate com vitaminas, ferro quelato (ferro de alta absorção) e zinco.'
    },
    {
      id: 3,
      name: 'Caldo Galinha',
      weight: '1kg',
      category: 'Caldo',
      image: 'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/00891f213e9dd39c820fc8627d8898ce.png',
      description: 'Caldo de galinha, preparo para caldo sabor galinha.'
    },
    {
      id: 14,
      name: 'Caldo Carne',
      weight: '1kg',
      category: 'Caldo',
      image: 'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/e40a27dd54285e3d6ca4a34f99955b9f.png',
      description: 'Caldo de carne, preparo para caldo sabor carne.'
    },
    {
      id: 4,
      name: 'Gelatina Uva',
      weight: '1 Kg',
      category: 'Gelatina',
      image: 'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/0aea70a1482976e30d89f198c893e43b.png',
      description: 'Gelatina em pó sabor uva, prática e deliciosa para grandes volumes.'
    },
    {
      id: 10,
      name: 'Gelatina Morango',
      weight: '1 Kg',
      category: 'Gelatina',
      image: 'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/e61f34019691789ee4275c3adc73bd4e.png',
      description: 'Gelatina em pó sabor morango, prática e deliciosa para grandes volumes.'
    },
    {
      id: 11,
      name: 'Gelatina Framboesa',
      weight: '1 Kg',
      category: 'Gelatina',
      image: 'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/8237220725243656e6aea2d36901ccd4.png',
      description: 'Gelatina em pó sabor framboesa, prática e deliciosa para grandes volumes.'
    },
    {
      id: 12,
      name: 'Gelatina Limão',
      weight: '1 Kg',
      category: 'Gelatina',
      image: 'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/3e2adb7d0084ebf66f8bf720427302fe.png',
      description: 'Gelatina em pó sabor limão, prática e deliciosa para grandes volumes.'
    },
    {
      id: 13,
      name: 'Gelatina Abacaxi',
      weight: '1 Kg',
      category: 'Gelatina',
      image: 'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/551ff55d4cdef2eeb2a2fa364af6733e.png',
      description: 'Gelatina em pó sabor abacaxi, prática e deliciosa para grandes volumes.'
    },
    {
      id: 5,
      name: 'Mingau',
      weight: '200g',
      category: 'Mingau',
      image: 'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/e3a6a795b5cc7433a7b1da36ad155f9f.png',
      description: 'Mingau de aveia instantâneo, nutritivo e prático para um café da manhã saudável.'
    },
    {
      id: 6,
      name: 'Purê de Batata',
      weight: '150g',
      category: 'Purê',
      image: 'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/d99f6e0bcbc4e5ec02098257ac53950a.png',
      description: 'Purê de batata instantâneo, cremoso e saboroso, pronto em minutos.'
    },
    {
      id: 7,
      name: 'Risoto sabor frango',
      weight: '175g',
      category: 'Risoto',
      image: 'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/47c684e1faa583cd7fd54b57ef7e9150.png',
      description: 'Risoto de funghi pronto, sabor sofisticado e preparo rápido para refeições especiais.'
    },
    {
      id: 15,
      name: 'Risoto sabor carne',
      weight: '1 kg',
      category: 'Risoto',
      image: 'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/8b45d35261430a4858486f66ad4d9487.png',
      description: 'Mistura para o preparo de risoto sabor carne (arroz à grega).'
    },
    {
      id: 8,
      name: 'Sopa de macarrão sabor frango',
      weight: '68g',
      category: 'Sopa',
      image: 'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/93147c46b10d99b8b9618608be6425e3.png',
      description: 'Sopa de legumes instantânea, nutritiva e reconfortante para qualquer momento do dia.'
    },
    {
      id: 9,
      name: 'Sopa de macarrão sabor carne',
      weight: '68g',
      category: 'Sopa',
      image: 'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/de4da2c3ada18bfca1fc87ffd1228283.png',
      description: 'Sopa de cebola instantânea, sabor marcante e tradicional, pronta em minutos.'
    }
  ];

  const categories = ['Achocolatado', 'Bebida', 'Caldo', 'Gelatina', 'Mingau', 'Purê', 'Risoto', 'Sopa'];

  const filteredProducts = selectedCategory === 'Todos' 
    ? products 
    : products.filter(product => product.category === selectedCategory);

  return (
    <div className="min-h-screen pt-20">
      {/* Hero Section */}
      <section 
        className="relative min-h-[60vh] flex items-center justify-center bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `linear-gradient(rgba(255, 152, 0, 0.85), rgba(255, 193, 7, 0.85)), url('https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/a58f32aa3e27c1d0663fe181d349d8b4.png')`
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-orange-900/20 via-amber-700/10 to-orange-900/20"></div>
        <div className="relative max-w-7xl mx-auto px-4 py-20 text-center w-full">
          <div className="mb-6 flex flex-col items-center">
            <img 
              src="https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/ac435f6d5b1a7055bcf07f711dd158e1.png" 
              alt="Nutrare Logo" 
              className="h-32 w-auto mb-8 drop-shadow-2xl"
            />
            <h1 className="text-5xl lg:text-7xl font-bold text-white leading-tight mb-6">
              <span className="block text-amber-200">Qualidade e Nutrição</span>
            </h1>
            <p className="text-xl lg:text-2xl text-white/95 max-w-3xl mx-auto leading-relaxed">
              Produtos essenciais para o dia a dia, com qualidade superior e preços acessíveis
            </p>
          </div>
        </div>
      </section>

      {/* Filter Section */}
      <section className="bg-gradient-to-br from-orange-50 to-amber-50 py-8 sticky top-20 z-40 shadow-md">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex flex-wrap gap-2 justify-center">
            <button
              onClick={() => setSelectedCategory('Todos')}
              className={`px-5 py-2.5 rounded-full font-medium transition-all duration-300 whitespace-nowrap cursor-pointer text-sm ${
                selectedCategory === 'Todos'
                  ? 'bg-gradient-to-r from-orange-500 to-amber-500 text-white shadow-lg scale-105'
                  : 'bg-white text-gray-700 hover:bg-orange-100 hover:text-orange-600 shadow-sm'
              }`}
            >
              Todos os Produtos
            </button>
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => setSelectedCategory(category)}
                className={`px-5 py-2.5 rounded-full font-medium transition-all duration-300 whitespace-nowrap cursor-pointer text-sm ${
                  selectedCategory === category
                    ? 'bg-gradient-to-r from-orange-500 to-amber-500 text-white shadow-lg scale-105'
                    : 'bg-white text-gray-700 hover:bg-orange-100 hover:text-orange-600 shadow-sm'
                }`}
              >
                {category}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Products Grid */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-product-shop>
            {filteredProducts.map((product) => (
              <div
                key={product.id}
                className="group bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden border border-orange-100 hover:border-orange-300 cursor-pointer"
                onClick={() => window.REACT_APP_NAVIGATE(`/nutrare/product-detail/${product.id}`)}
              >
                <div className="relative h-72 overflow-hidden bg-gradient-to-br from-orange-50 to-amber-50">
                  <img
                    src={product.image}
                    alt={product.name}
                    className="w-full h-full object-contain object-center p-6 group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute top-4 right-4 bg-gradient-to-r from-orange-500 to-amber-500 text-white px-4 py-2 rounded-full text-sm font-semibold shadow-lg">
                    {product.category}
                  </div>
                </div>
                <div className="p-6">
                  <h3 className="text-2xl font-bold text-gray-800 mb-3 group-hover:text-orange-600 transition-colors">
                    {product.name}
                  </h3>
                  <p className="text-gray-600 mb-4 line-clamp-2">
                    {product.description}
                  </p>
                  <div className="flex items-center justify-between">
                    <span className="text-orange-600 font-semibold text-lg">
                      Ver Detalhes
                    </span>
                    <div className="w-10 h-10 bg-gradient-to-r from-orange-500 to-amber-500 rounded-full flex items-center justify-center text-white group-hover:scale-110 transition-transform">
                      <i className="ri-arrow-right-line text-xl"></i>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-orange-500 via-amber-500 to-orange-600">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
            Qualidade Nutrare em Cada Produto
          </h2>
          <p className="text-xl text-white/95 mb-8 leading-relaxed">
            Descubra nossa linha completa de produtos essenciais para sua cozinha
          </p>
          <a 
            href="https://wa.me/5519998928137"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center px-8 py-4 bg-white text-orange-600 font-semibold rounded-full hover:bg-orange-50 transition-all duration-300 shadow-xl hover:shadow-2xl hover:scale-105 cursor-pointer whitespace-nowrap"
          >
            Entre em Contato
            <i className="ri-arrow-right-line ml-2 text-xl"></i>
          </a>
        </div>
      </section>
    </div>
  );
};

export default NutrarePage;
